import React from 'react';
import { View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

import { ThemedText } from '@/components/themed-text';
import { RecurrenceSummary } from '@/types/recurrence';
import { formatCurrency } from '@/utils/format-currency';
import {
  recurrenceScheduleLines,
  recurrencePeriodLabel,
} from '@/utils/format-recurrence';

/**
 * Pedido de recorrência/assinatura esperando o prestador aprovar. Ainda não
 * virou agendamento — sem este card a tela fica vazia logo após o pedido,
 * como se ele tivesse se perdido.
 */
export function PendingRecurrenceCard({ item }: { item: RecurrenceSummary }) {
  const lines = recurrenceScheduleLines(item);
  return (
    <View
      className="gap-2 rounded-2xl border border-amber-200 bg-amber-50 p-4"
      style={{ borderCurve: 'continuous' }}
    >
      <View className="flex-row items-center gap-2">
        <Ionicons className="text-amber-700" name="hourglass-outline" size={16} />
        <ThemedText className="text-xs font-bold uppercase text-amber-700">
          Recorrência pedida
        </ThemedText>
      </View>
      <ThemedText className="text-base font-bold">
        {item.service?.name ?? 'Serviço'}
      </ThemedText>
      {lines.map((line, index) => (
        <ThemedText key={index} className="text-sm text-neutral-600">
          {line}
        </ThemedText>
      ))}
      <ThemedText className="text-sm text-neutral-600">
        {recurrencePeriodLabel(item)}
        {item.price ? ` · ${formatCurrency(item.price)}` : ''}
      </ThemedText>
      <ThemedText className="text-xs text-amber-700">
        O prestador ainda pode recusar este pedido.
      </ThemedText>
    </View>
  );
}
